import React from "react";
import { Link } from "react-router-dom";

import "./InstantQuote.css";

const InstantQuote = ({ black }) => {
  return (
    <div
      style={{
        backgroundColor: black ? "#1D212A" : "",
        color: black ? "#fff" : "",
      }}
      className="instantQuote my-40 text-center py-20 px-40 w-100"
    >
      <h2 className="font-heading pb-10 pt-20 mx-auto">Get an instant quote</h2>
      <p className="font-heavy font-normal">
        Get your documents translated in less than 24 hours.
        <br />
        We deliver faster than you can imagine, trust us once and trust us
        forever
      </p>
      <Link to="/quote">
        <button className="button my-20">Instant quote</button>
      </Link>
    </div>
  );
};

export default InstantQuote;
